import { render, staticRenderFns } from "./CreateBudget.vue?vue&type=template&id=72942c8a&scoped=true"
import script from "./CreateBudget.vue?vue&type=script&lang=js"
export * from "./CreateBudget.vue?vue&type=script&lang=js"
import style0 from "./CreateBudget.vue?vue&type=style&index=0&id=72942c8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72942c8a",
  null
  
)

export default component.exports